module.exports = __webpack_public_path__ + "img/yj_exchange_in_app.06d67112.png";